import * as React from 'react';
import styled from 'react-emotion';
import Downshift from 'downshift';
import { Transition } from 'react-transition-group';
import { styles } from './styles';
import { animations } from './animations';

import { Group } from '../Group';

interface ItemProps {
  groupFirst: boolean;
  groupLast: boolean;
  isActive: boolean;
}

const Item = styled<'div'>('div')<ItemProps>(({ groupFirst, groupLast, isActive }) =>
  styles.row(groupFirst, groupLast, isActive)
);

interface Props<T> {
  items: Array<T>;
  selectedItem: T;
  onChange: (item: T) => void;
  displayFunc: (item: T) => string;
  groupFirst?: boolean;
  groupLast?: boolean;
}

export class Dropdown<T extends {}> extends React.Component<Props<T>, {}> {
  render() {
    const { items, selectedItem, onChange, displayFunc, groupFirst, groupLast } = this.props;
    return (
      <Downshift selectedItem={selectedItem} onChange={onChange} itemToString={displayFunc}>
        {({
          isOpen,
          getToggleButtonProps,
          getItemProps,
          highlightedIndex,
          selectedItem: dsSelectedItem,
          itemToString
        }) => (
          <div className={styles.dropdownWrapper}>
            <div className={styles.toggle} {...getToggleButtonProps()}>
              {selectedItem ? itemToString(selectedItem) : 'Select an item ...'}
              <span className={styles.arrowDown(isOpen)} />
            </div>
            <div className={styles.rowWrapper}>
              {
                <Transition
                  appear={true}
                  unmountOnExit={true}
                  in={isOpen}
                  timeout={{
                    enter: 0,
                    exit: 150
                  }}
                >
                  {(state: string) => {
                    return (
                      <div className={`${styles.rowWrapperFixed} ${animations.dropdown[state]}`}>
                        <Group noFocus={true}>
                          {items.map((item, index) => (
                            <Item
                              groupFirst={groupFirst}
                              groupLast={groupLast}
                              {...getItemProps({
                                item,
                                selected: highlightedIndex === index,
                                isSelected: dsSelectedItem === item
                              } as any)}
                              key={itemToString(item)}
                            >
                              {itemToString(item)}
                            </Item>
                          ))}
                        </Group>
                      </div>
                    );
                  }}
                </Transition>
              }
            </div>
          </div>
        )}
      </Downshift>
    );
  }
}
